<template>
  <selectTree
    :data="orgTree"
    v-model="modelValue"
    :multiple="multiple"
    :disabled="disabled"
    :size="null"
    :single="true"
    :clearable="true"
    placeholder="请选择"
    :selectAllChildren="selectAllChildren"
    @onChange="selectNode"
  ></selectTree>
</template>
<script>
import selectTree from "./selectTree/index";
export default {
  components:{selectTree},
  props: {
    value: null,
    disabled:{
      default: false
    },
    multiple:{
      default: false
    },
    selectAllChildren:{
      default: false
    },
    params:{
      default: ()=>{
        return {
          source:1,
        }
      }
    },
    httpUrl:{
      default: "/buz/organizationBase/read/orgTree"
    }
  },
  data() {
    return {
      modelValue:[],
      oldValue:[],
      orgTree:[],
    };
  },
  watch:{
    value:{
      handler: function (val, oldVal) {
        this.modelValue = this.value||[];
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    init(){
      this.$http({
        url: this.httpUrl,
        type: "POST",
        data: this.params
      }).then(res => {
        this.orgTree = this.dealTree([res.data]);
        this.$emit('getOrgTreeData', this.orgTree);
      })
    },
    // 转换组织树结构
    dealTree(arr) {
      return arr.map((item) => ({
        ...item,
        expand: item.nodeType === 1 ? true : false,
        value: item.id,
        label: item.name + (item.code?'-':'') + item.code,
        children:
          item.children && item.children.length > 0
            ? this.dealTree(item.children)
            : null,
      }));
    },
    selectNode(){
      this.$emit("input",this.modelValue);
      this.$emit("change",this.modelValue);
    },
  },

};
</script>

<style lang="scss" scoped>
.ivu-transfer {
  text-align: center;
  /deep/ .ivu-transfer-list {
    text-align: left;
  }
}
.powerModal {
  /deep/ .ivu-modal-body {
    height: 500px;
    overflow-y: auto;
  }
}
</style>
